import { render } from "./LitigationCreator.vue?vue&type=template&id=73ca06e0&scoped=true"
import script from "./LitigationCreator.vue?vue&type=script&lang=js"
export * from "./LitigationCreator.vue?vue&type=script&lang=js"

import "./LitigationCreator.vue?vue&type=style&index=0&id=73ca06e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ca06e0"]])

export default __exports__